

import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  FaMapMarkerAlt, FaBed, FaBath, FaCar, FaRulerCombined,
  FaBuilding, FaHome, FaLayerGroup, FaLeaf, FaSwimmingPool,
  FaBalanceScale, FaWater, FaCheckCircle, FaArrowLeft,
} from "react-icons/fa";
import { MdBalcony, MdOutlineOtherHouses } from "react-icons/md";
import { BsGrid3X3Gap } from "react-icons/bs";
import axios from "axios";
import AppContext from "context/AppContext";
import "../../../assets/css/Buyer/agents/agentpropertydetails.css";
import Footer from "components/Buyer/footer/Footer";
import HeroSection from "subscreens/general/pageheros/HeroSection";
import MyNavbar from "components/Buyer/navbar/MyNavbar";

// ─── Amenity icon map ─────────────────────────────────────────
const AMENITY_ICONS = {
  "Swimming Pool":    <FaSwimmingPool />,
  "Garden":          <FaLeaf />,
  "Balcony":         <MdBalcony />,
  "Servant Quarters":<FaHome />,
  "Lift":            <FaBuilding />,
  "Parking":         <FaCar />,
  "Corner Plot":     <BsGrid3X3Gap />,
};

const getAmenityIcon = (feature) => {
  const key = Object.keys(AMENITY_ICONS).find(k =>
    feature.toLowerCase().includes(k.toLowerCase())
  );
  return key ? AMENITY_ICONS[key] : <FaCheckCircle />;
};

// ─── Spec Chip ────────────────────────────────────────────────
const AgtSpecChip = ({ icon, label, value }) => (
  <div className="agt-spec-chip">
    <span className="agt-spec-chip__icon">{icon}</span>
    <div className="agt-spec-chip__text">
      <span className="agt-spec-chip__val">{value}</span>
      <span className="agt-spec-chip__lbl">{label}</span>
    </div>
  </div>
);

// ─── Detail Row ───────────────────────────────────────────────
const AgtDetailRow = ({ label, value }) => (
  value ? (
    <div className="agt-detail-row">
      <span className="agt-detail-row__label">{label}</span>
      <span className="agt-detail-row__value">{value}</span>
    </div>
  ) : null
);

// ─── Main Component ───────────────────────────────────────────
const AgentPropertyDetails = () => {

  const location = useLocation();


const property = location.state?.property;
  const { id } = useParams();

  const { Navigate,baseUrl, baseUrlForFiles } = useContext(AppContext);

  // const [property, setProperty]         = useState([]);
  // const [loading, setLoading]           = useState(true);
  const [activeImg, setActiveImg]       = useState(0);



  // ── Loading ─────────────────────────────────────────────────
  // if (loading) {
  //   return (
  //     <div className="agt-loading">
  //       <div className="agt-loading__spinner"></div>
  //       <p>Loading property details...</p>
  //     </div>
  //   );
  // }

  // ── Not found ───────────────────────────────────────────────
  if (!property) {
    return (
      <div className="agt-not-found">
        <FaHome size={52} />
        <h2>Property Not Found</h2>
        <button className="agt-back-btn" onClick={() => Navigate(-1)}>
          <FaArrowLeft /> Go Back
        </button>
      </div>
    );
  }

  // ── Images array ────────────────────────────────────────────
  const images =
    property.expropertyimages?.length > 0
      ? property.expropertyimages.map((img) => `${baseUrlForFiles}${img.images}`)
      : ["https://via.placeholder.com/900x500?text=No+Image"];

  // ── Features array ──────────────────────────────────────────
  const featuresArr = property.features
    ? property.features.split(",").map((f) => f.trim()).filter(Boolean)
    : [];

  // ── Boolean amenities from fillable ─────────────────────────
  const boolAmenities = [
    { label: "Garden Available",   val: property.garden_available,   icon: <FaLeaf /> },
    { label: "Balcony",            val: property.balcony,            icon: <MdBalcony /> },
    { label: "Servant Quarters",   val: property.servant_quarters,   icon: <FaHome /> },
    { label: "Swimming Pool",      val: property.swimming_pool,      icon: <FaSwimmingPool /> },
    { label: "Corner Plot",        val: property.corner_plot,        icon: <BsGrid3X3Gap /> },
    { label: "Boundary Wall",      val: property.boundary_wall,      icon: <FaBalanceScale /> },
    { label: "Lift Available",     val: property.lift_available,     icon: <FaBuilding /> },
  ].filter((a) => a.val == 1 || a.val === true || a.val === "1");

  const listingLabel = property.listingType === "FOR RENT" ? "For Rent" : "For Sale";
  const listingClass = property.listingType === "FOR RENT" ? "rent" : "sale";

  return (
    <>
      <MyNavbar />
      <HeroSection
        title="Agents Property Details"
        subtitle="Explore more property details"
        // label="Professional Team"
        image="https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1920"
      // align="left"
      // size="lg"
      />
    <div className="agt-page">

      {/* ── Back button ── */}
      <button className="agt-back-btn" onClick={() => Navigate(-1)}>
        <FaArrowLeft />
        <span>Back</span>
      </button>

      {/* ══════════════════════════════════════════
          HERO SECTION — Title + Price + Location
         ══════════════════════════════════════════ */}
      <div className="agt-hero">
        <div className="agt-hero__left">
          <div className="agt-hero__badges">
            <span className={`agt-listing-badge agt-listing-badge--${listingClass}`}>
              {listingLabel}
            </span>
            <span className={`agt-status-badge agt-status-badge--${(property.status || "Active").toLowerCase()}`}>
              {property.status || "Active"}
            </span>
          </div>
          <h1 className="agt-hero__title">{property.property_title}</h1>
          <div className="agt-hero__location">
            <FaMapMarkerAlt />
            <span>{property.location}, {property.city}</span>
          </div>
        </div>

        <div className="agt-hero__right">
          <p className="agt-hero__price">{property.price}</p>
          {property.size && (
            <p className="agt-hero__per-unit">
              {property.size}
            </p>
          )}
        </div>
      </div>

      {/* ══════════════════════════════════════════
          IMAGE GALLERY — 1 large + right grid
         ══════════════════════════════════════════ */}
      <div className="agt-gallery">

        {/* Main image */}
        <div className="agt-gallery__main">
          <img
            src={images[activeImg]}
            alt={property.property_title}
            className="agt-gallery__main-img"
          />
          <div className="agt-gallery__counter">
            {activeImg + 1} / {images.length}
          </div>
        </div>

        {/* Side thumbnails grid — show up to 4 */}
        {/* {images.length > 1 && (
          <div className="agt-gallery__side">
            {images.slice(1, 5).map((img, i) => {
              const realIdx = i + 1;
              const isLast = realIdx === 4 && images.length > 5;
              return (
                <div
                  key={i}
                  className={`agt-gallery__thumb-wrap ${activeImg === realIdx ? "agt-gallery__thumb-wrap--active" : ""}`}
                  onClick={() => setActiveImg(realIdx)}
                >
                  <img
                    src={img}
                    alt={`View ${realIdx + 1}`}
                    className="agt-gallery__thumb"
                  />
                  {isLast && (
                    <div className="agt-gallery__more-overlay">
                      +{images.length - 5} more
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )} */}
      </div>

      {/* Thumbnail strip below */}
      {images.length > 1 && (
        <div className="agt-thumb-strip">
          {images.map((img, i) => (
            <img
              key={i}
              src={img}
              alt={`Thumb ${i + 1}`}
              className={`agt-thumb-strip__item ${activeImg === i ? "agt-thumb-strip__item--active" : ""}`}
              onClick={() => setActiveImg(i)}
            />
          ))}
        </div>
      )}

      {/* ══════════════════════════════════════════
          SPECS BAR — Bedrooms, Bathrooms, etc.
         ══════════════════════════════════════════ */}
      <div className="agt-specs-bar">
        {property.bedrooms > 0 && (
          <AgtSpecChip icon={<FaBed />}          label="Bedrooms"       value={property.bedrooms} />
        )}
        {property.bathrooms > 0 && (
          <AgtSpecChip icon={<FaBath />}         label="Bathrooms"      value={property.bathrooms} />
        )}
        {property.size && (
          <AgtSpecChip icon={<FaRulerCombined />} label="Sq. Ft."       value={property.size} />
        )}
        {property.parking_spaces > 0 && (
          <AgtSpecChip icon={<FaCar />}          label="Parking"        value={property.parking_spaces} />
        )}
        {property.floors > 0 && (
          <AgtSpecChip icon={<FaLayerGroup />}   label="Floors"         value={property.floors} />
        )}
        {property.land_area && (
          <AgtSpecChip icon={<FaRulerCombined />} label="Land Area"     value={property.land_area} />
        )}
      </div>

      {/* ══════════════════════════════════════════
          CONTENT GRID — Details Left, Sidebar Right
         ══════════════════════════════════════════ */}
      <div className="agt-content-grid">

        {/* ── LEFT COLUMN ── */}
        <div className="agt-content-left">

          {/* Description */}
          {property.description && (
            <section className="agt-section">
              <h3 className="agt-section__title">Property Description</h3>
              <p className="agt-section__desc">{property.description}</p>
            </section>
          )}

          {/* Amenities / Features */}
          {(featuresArr.length > 0 || boolAmenities.length > 0) && (
            <section className="agt-section">
              <h3 className="agt-section__title">Amenities</h3>
              <div className="agt-amenities-grid">
                {/* Text features from comma-separated */}
                {featuresArr.map((f, i) => (
                  <div key={i} className="agt-amenity-chip">
                    <span className="agt-amenity-chip__icon">{getAmenityIcon(f)}</span>
                    <span className="agt-amenity-chip__label">{f}</span>
                  </div>
                ))}
                {/* Boolean amenities from fillable */}
                {boolAmenities.map((a, i) => (
                  <div key={`bool-${i}`} className="agt-amenity-chip">
                    <span className="agt-amenity-chip__icon">{a.icon}</span>
                    <span className="agt-amenity-chip__label">{a.label}</span>
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* Property Details Table */}
          <section className="agt-section">
            <h3 className="agt-section__title">Property Details</h3>
            <div className="agt-details-card">
              <AgtDetailRow label="Property Type"   value={property.property_type} />
              <AgtDetailRow label="Listing Type"    value={listingLabel} />
              <AgtDetailRow label="Status"          value={property.status} />
              <AgtDetailRow label="City"            value={property.city} />
              <AgtDetailRow label="Location"        value={property.location} />
              <AgtDetailRow label="Full Address"    value={property.full_address} />
              <AgtDetailRow label="Size"            value={property.size} />
              <AgtDetailRow label="Land Area"       value={property.land_area} />
              <AgtDetailRow label="Floors"          value={property.floors} />
              <AgtDetailRow label="Property Stage"  value={property.property_stage} />
              <AgtDetailRow label="Plot Number"     value={property.plot_number} />
              <AgtDetailRow label="Commercial Type" value={property.commercial_type} />
              <AgtDetailRow label="Water Source"    value={property.water_source} />
            </div>
          </section>

        </div>

        {/* ── RIGHT SIDEBAR ── */}
        <div className="agt-sidebar">

          {/* Price Card */}
          <div className="agt-price-card">
            <div className="agt-price-card__top">
              <span className="agt-price-card__label">Listed Price</span>
              <h3 className="agt-price-card__price">{property.price}</h3>
            </div>

            <div className="agt-price-card__divider"></div>

            {/* Quick info */}
            <div className="agt-price-card__info">
              <div className="agt-price-card__info-row">
                <span>Type</span>
                <span>{property.property_type}</span>
              </div>
              <div className="agt-price-card__info-row">
                <span>Status</span>
                <span className={`agt-status-dot agt-status-dot--${(property.status || "active").toLowerCase()}`}>
                  {property.status || "Active"}
                </span>
              </div>
              <div className="agt-price-card__info-row">
                <span>Listing</span>
                <span style={{ color: listingClass === "rent" ? "#3b82f6" : "#10b981", fontWeight: 700 }}>
                  {listingLabel}
                </span>
              </div>
              {property.city && (
                <div className="agt-price-card__info-row">
                  <span>City</span>
                  <span>{property.city}</span>
                </div>
              )}
            </div>
          </div>

          {/* Address Card */}
          {property.full_address && (
            <div className="agt-address-card">
              <h4 className="agt-address-card__title">
                <FaMapMarkerAlt /> Full Address
              </h4>
              <p className="agt-address-card__text">{property.full_address}</p>
            </div>
          )}

        </div>

      </div>
    </div>
    <Footer/>
    </>
  );
};

export default AgentPropertyDetails;